import React from 'react';

import * as FileConstants from 'folder-items/FileConstants';
import DateField from 'ui-library/inputs/DateField';
import {DatetimePickerRef} from 'ui-library/inputs/InputConstants';
import {tryParseDate} from 'util/DateUtil';
import {ElementKeyboardEvent} from 'util/Types';

interface DateValueEditorProps {
  autoFocus: boolean;
  defaultValue?: FileConstants.SchemaTag | null;
  onChange: (values: {value: string; dateValue: string | null}) => void;
  onKeyDown?: (e: ElementKeyboardEvent) => void;
  placeholder?: string;
  datePickerPopperContainerSelector?: string;
  wrapperClassName?: string;
  datetimePickerRef?: DatetimePickerRef;
}

export default function DateValueEditor(props: DateValueEditorProps): JSX.Element {
  const handleChange = (value: string): void => {
    const dateValue = tryParseDate(value) ? value : null;
    props.onChange({value, dateValue});
  };

  return (
    <DateField
      autoFocus={props.autoFocus}
      labelStyle={DateField.LABEL_STYLES.HIDDEN}
      placeholder={props.placeholder ?? 'Date'}
      onChange={handleChange}
      onKeyDown={props.onKeyDown}
      value={props.defaultValue ? props.defaultValue.value : null}
      datePickerPopperContainerSelector={props.datePickerPopperContainerSelector}
      wrapperClassName={props.wrapperClassName}
      datetimePickerRef={props.datetimePickerRef}
    />
  );
}
